import { createStyles, makeStyles } from '@material-ui/core/styles';

import { colorsPalette, SMALL_MARGIN } from '../../../theme';

const useStyles = makeStyles(() =>
  createStyles({
    wrapper: {
      padding: SMALL_MARGIN,
      background: colorsPalette.violetAnalyticsCard,
      borderRadius: 5,
      display: 'flex',
      alignItems: 'center',
      color: colorsPalette.white,
      fontWeight: 'bold',
      fontSize: 14,
      lineHeight: 1.2,
      whiteSpace: 'nowrap',
      '& svg': {
        width: 18,
        height: 18,
        marginRight: 9,
      },
    },
  }),
);

export default useStyles;
